import { WorkOrderDocumentationChecklist } from '../types';

export const DOCUMENTATION_STATUS_COMPLETED = 'Completed';
export const DOCUMENTATION_STATUS_READY_TO_INVOICE = 'Ready to Invoice';
export const INVOICE_ALLOWED_STATUSES = [
  DOCUMENTATION_STATUS_READY_TO_INVOICE,
  'Invoiced',
  'Paid and Closed',
];

export const isDocumentationStatusName = (statusName: string | undefined, expected: string): boolean =>
  (statusName ?? '').trim().toLowerCase() === expected.trim().toLowerCase();

export const canCreateWorkOrderInvoice = (
  statusName: string | undefined,
  checklist?: WorkOrderDocumentationChecklist | null
): boolean => {
  const statusAllowed = INVOICE_ALLOWED_STATUSES.some((status) =>
    isDocumentationStatusName(statusName, status)
  );
  return statusAllowed && (checklist?.isComplete ?? false);
};

export const getDocumentationItemClasses = (complete: boolean): string =>
  complete
    ? 'text-green-700 dark:text-green-300'
    : 'text-red-700 dark:text-red-300';
